import { render } from "./SidebarBody.vue?vue&type=template&id=7789481e&scoped=true"
import script from "./SidebarBody.vue?vue&type=script&lang=js"
export * from "./SidebarBody.vue?vue&type=script&lang=js"

import "./SidebarBody.vue?vue&type=style&index=0&id=7789481e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7789481e"]])

export default __exports__